export const COUNTRIES = [
  { code: 'AFG', name: 'Afghanistan', currency: 'AFN', symbol: '؋', dialCode: '+93' },
  { code: 'ALB', name: 'Albania', currency: 'ALL', symbol: 'L', dialCode: '+355' },
  { code: 'DZA', name: 'Algeria', currency: 'DZD', symbol: 'د.ج', dialCode: '+213' },
  { code: 'ARG', name: 'Argentina', currency: 'ARS', symbol: '$', dialCode: '+54' },
  { code: 'AUS', name: 'Australia', currency: 'AUD', symbol: '$', dialCode: '+61' },
  { code: 'AUT', name: 'Austria', currency: 'EUR', symbol: '€', dialCode: '+43' },
  { code: 'BHR', name: 'Bahrain', currency: 'BHD', symbol: '.د.ب', dialCode: '+973' },
  { code: 'BGD', name: 'Bangladesh', currency: 'BDT', symbol: '৳', dialCode: '+880' },
  { code: 'BLR', name: 'Belarus', currency: 'BYN', symbol: 'Br', dialCode: '+375' },
  { code: 'BEL', name: 'Belgium', currency: 'EUR', symbol: '€', dialCode: '+32' },
  { code: 'BRA', name: 'Brazil', currency: 'BRL', symbol: 'R$', dialCode: '+55' },
  { code: 'BGR', name: 'Bulgaria', currency: 'BGN', symbol: 'лв', dialCode: '+359' },
  { code: 'CAN', name: 'Canada', currency: 'CAD', symbol: '$', dialCode: '+1' },
  { code: 'CHL', name: 'Chile', currency: 'CLP', symbol: '$', dialCode: '+56' },
  { code: 'CHN', name: 'China', currency: 'CNY', symbol: '¥', dialCode: '+86' },
  { code: 'COL', name: 'Colombia', currency: 'COP', symbol: '$', dialCode: '+57' },
  { code: 'HRV', name: 'Croatia', currency: 'EUR', symbol: '€', dialCode: '+385' },
  { code: 'CZE', name: 'Czech Republic', currency: 'CZK', symbol: 'Kč', dialCode: '+420' },
  { code: 'DNK', name: 'Denmark', currency: 'DKK', symbol: 'kr', dialCode: '+45' },
  { code: 'EGY', name: 'Egypt', currency: 'EGP', symbol: '£', dialCode: '+20' },
  { code: 'EST', name: 'Estonia', currency: 'EUR', symbol: '€', dialCode: '+372' },
  { code: 'FIN', name: 'Finland', currency: 'EUR', symbol: '€', dialCode: '+358' },
  { code: 'FRA', name: 'France', currency: 'EUR', symbol: '€', dialCode: '+33' },
  { code: 'GEO', name: 'Georgia', currency: 'GEL', symbol: '₾', dialCode: '+995' },
  { code: 'DEU', name: 'Germany', currency: 'EUR', symbol: '€', dialCode: '+49' },
  { code: 'GRC', name: 'Greece', currency: 'EUR', symbol: '€', dialCode: '+30' },
  { code: 'HKG', name: 'Hong Kong', currency: 'HKD', symbol: '$', dialCode: '+852' },
  { code: 'HUN', name: 'Hungary', currency: 'HUF', symbol: 'Ft', dialCode: '+36' },
  { code: 'ISL', name: 'Iceland', currency: 'ISK', symbol: 'kr', dialCode: '+354' },
  { code: 'IND', name: 'India', currency: 'INR', symbol: '₹', dialCode: '+91' },
  { code: 'IDN', name: 'Indonesia', currency: 'IDR', symbol: 'Rp', dialCode: '+62' },
  { code: 'IRN', name: 'Iran', currency: 'IRR', symbol: '﷼', dialCode: '+98' },
  { code: 'IRQ', name: 'Iraq', currency: 'IQD', symbol: 'ع.د', dialCode: '+964' },
  { code: 'IRL', name: 'Ireland', currency: 'EUR', symbol: '€', dialCode: '+353' },
  { code: 'ISR', name: 'Israel', currency: 'ILS', symbol: '₪', dialCode: '+972' },
  { code: 'ITA', name: 'Italy', currency: 'EUR', symbol: '€', dialCode: '+39' },
  { code: 'JPN', name: 'Japan', currency: 'JPY', symbol: '¥', dialCode: '+81' },
  { code: 'JOR', name: 'Jordan', currency: 'JOD', symbol: 'د.ا', dialCode: '+962' },
  { code: 'KAZ', name: 'Kazakhstan', currency: 'KZT', symbol: '₸', dialCode: '+7' },
  { code: 'KEN', name: 'Kenya', currency: 'KES', symbol: 'Sh', dialCode: '+254' },
  { code: 'KWT', name: 'Kuwait', currency: 'KWD', symbol: 'د.ك', dialCode: '+965' },
  { code: 'KGZ', name: 'Kyrgyzstan', currency: 'KGS', symbol: 'с', dialCode: '+996' },
  { code: 'LVA', name: 'Latvia', currency: 'EUR', symbol: '€', dialCode: '+371' },
  { code: 'LBN', name: 'Lebanon', currency: 'LBP', symbol: 'ل.ل', dialCode: '+961' },
  { code: 'LTU', name: 'Lithuania', currency: 'EUR', symbol: '€', dialCode: '+370' },
  { code: 'MYS', name: 'Malaysia', currency: 'MYR', symbol: 'RM', dialCode: '+60' },
  { code: 'MEX', name: 'Mexico', currency: 'MXN', symbol: '$', dialCode: '+52' },
  { code: 'MAR', name: 'Morocco', currency: 'MAD', symbol: 'د.م.', dialCode: '+212' },
  { code: 'NLD', name: 'Netherlands', currency: 'EUR', symbol: '€', dialCode: '+31' },
  { code: 'NZL', name: 'New Zealand', currency: 'NZD', symbol: '$', dialCode: '+64' },
  { code: 'NGA', name: 'Nigeria', currency: 'NGN', symbol: '₦', dialCode: '+234' },
  { code: 'NOR', name: 'Norway', currency: 'NOK', symbol: 'kr', dialCode: '+47' },
  { code: 'OMN', name: 'Oman', currency: 'OMR', symbol: 'ر.ع.', dialCode: '+968' },
  { code: 'PAK', name: 'Pakistan', currency: 'PKR', symbol: '₨', dialCode: '+92' },
  { code: 'PHL', name: 'Philippines', currency: 'PHP', symbol: '₱', dialCode: '+63' },
  { code: 'POL', name: 'Poland', currency: 'PLN', symbol: 'zł', dialCode: '+48' },
  { code: 'PRT', name: 'Portugal', currency: 'EUR', symbol: '€', dialCode: '+351' },
  { code: 'QAT', name: 'Qatar', currency: 'QAR', symbol: 'ر.ق', dialCode: '+974' },
  { code: 'ROU', name: 'Romania', currency: 'RON', symbol: 'lei', dialCode: '+40' },
  { code: 'RUS', name: 'Russia', currency: 'RUB', symbol: '₽', dialCode: '+7' },
  { code: 'SAU', name: 'Saudi Arabia', currency: 'SAR', symbol: 'ر.س', dialCode: '+966' },
  { code: 'SRB', name: 'Serbia', currency: 'RSD', symbol: 'дин', dialCode: '+381' },
  { code: 'SGP', name: 'Singapore', currency: 'SGD', symbol: '$', dialCode: '+65' },
  { code: 'SVK', name: 'Slovakia', currency: 'EUR', symbol: '€', dialCode: '+421' },
  { code: 'SVN', name: 'Slovenia', currency: 'EUR', symbol: '€', dialCode: '+386' },
  { code: 'ZAF', name: 'South Africa', currency: 'ZAR', symbol: 'R', dialCode: '+27' },
  { code: 'KOR', name: 'South Korea', currency: 'KRW', symbol: '₩', dialCode: '+82' },
  { code: 'ESP', name: 'Spain', currency: 'EUR', symbol: '€', dialCode: '+34' },
  { code: 'LKA', name: 'Sri Lanka', currency: 'LKR', symbol: 'Rs', dialCode: '+94' },
  { code: 'SWE', name: 'Sweden', currency: 'SEK', symbol: 'kr', dialCode: '+46' },
  { code: 'CHE', name: 'Switzerland', currency: 'CHF', symbol: 'Fr', dialCode: '+41' },
  { code: 'SYR', name: 'Syria', currency: 'SYP', symbol: '£', dialCode: '+963' },
  { code: 'TWN', name: 'Taiwan', currency: 'TWD', symbol: '$', dialCode: '+886' },
  { code: 'THA', name: 'Thailand', currency: 'THB', symbol: '฿', dialCode: '+66' },
  { code: 'TUR', name: 'Turkey', currency: 'TRY', symbol: '₺', dialCode: '+90' },
  { code: 'UKR', name: 'Ukraine', currency: 'UAH', symbol: '₴', dialCode: '+380' },
  { code: 'ARE', name: 'United Arab Emirates', currency: 'AED', symbol: 'د.إ', dialCode: '+971' },
  { code: 'GBR', name: 'United Kingdom', currency: 'GBP', symbol: '£', dialCode: '+44' },
  { code: 'USA', name: 'United States', currency: 'USD', symbol: '$', dialCode: '+1' },
  { code: 'UZB', name: 'Uzbekistan', currency: 'UZS', symbol: 'so\'m', dialCode: '+998' },
  { code: 'VNM', name: 'Vietnam', currency: 'VND', symbol: '₫', dialCode: '+84' },
  { code: 'YEM', name: 'Yemen', currency: 'YER', symbol: '﷼', dialCode: '+967' },
].sort((a, b) => a.name.localeCompare(b.name));

export const CURRENCY_SYMBOLS = {
  USD: '$',        // United States
  SAR: 'ر.س',     // Saudi Arabia
  AED: 'د.إ',     // UAE
  INR: '₹',        // India
  PKR: 'Rs',       // Pakistan
  EUR: '€',        // Europe
  GBP: '£',        // UK
  JPY: '¥',        // Japan
  CNY: '¥',        // China
  KWD: 'د.ك',     // Kuwait
  BHD: '.د.ب',    // Bahrain
  OMR: 'ر.ع.',    // Oman
  QAR: 'ر.ق',     // Qatar
  EGY: 'ج.م',     // Egypt
  JOD: 'د.ا',     // Jordan
  KGS: 'с',        // Kyrgyzstan
  CAD: '$',        // Canada
  AUD: '$',        // Australia
  SGD: '$',        // Singapore
  MYR: 'RM',       // Malaysia
  THB: '฿',        // Thailand
  PHP: '₱',        // Philippines
  IDR: 'Rp',       // Indonesia
  VND: '₫',        // Vietnam
  KRW: '₩',        // South Korea
  TRY: '₺',        // Turkey
  ZAR: 'R',        // South Africa
  NGN: '₦',        // Nigeria
  KES: 'Sh',       // Kenya
  BRL: 'R$',       // Brazil
  MXN: '$',        // Mexico
  ARS: '$',        // Argentina
  CLP: '$',        // Chile
  RUB: '₽',        // Russia
  PLN: 'zł',       // Poland
  SEK: 'kr',       // Sweden
  NOK: 'kr',       // Norway
  DKK: 'kr',       // Denmark
  CHF: 'Fr',       // Switzerland
  CZK: 'Kč',       // Czech Republic
  HUF: 'Ft',       // Hungary
  ILS: '₪',        // Israel
  NZD: '$',        // New Zealand
  HKD: '$',        // Hong Kong
  TWD: '$',        // Taiwan
};

export const FREE_TIER_LIMIT = 50; // Free users: 50 transactions per month

// Live WhatsApp business number (Twilio sender)
export const WHATSAPP_NUMBER = '17373163545';
export const WHATSAPP_DISPLAY = '+1 (737) 316-3545';
export const WHATSAPP_LINK = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent('Hi MoneyFeed! I want to start tracking my expenses.')}`;
